export default {
  label: {
    fontSize: 20,
  },

  tags: {
    display: 'flex',
  },
};
